import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ModerateTableRow;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
/* eslint "array-callback-return": "warn" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AccessibleContent, PresentationContent } from '@instructure/ui-a11y-content';
import { List } from '@instructure/ui-list';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { Avatar } from '@instructure/ui-avatar';
import { View } from '@instructure/ui-view';
import { Table } from '@instructure/ui-table';
import { IconEditLine, IconWarningLine, IconWarningSolid } from '@instructure/ui-icons';
import { IconButton } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import FormattedDuration from '../../../../common/components/shared/FormattedDuration';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Tooltip } from '@instructure/ui-tooltip';
var DASHES = '---';
export var ModerateTableRow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ModerateTableRow = /*#__PURE__*/function (_withI18nSupport) {
  function ModerateTableRow() {
    var _this2;
    _classCallCheck(this, ModerateTableRow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ModerateTableRow, [].concat(args));
    _defineProperty(_this2, "handleModerateRef", function (node) {
      _this2.moderateButton = node;
    });
    // =============
    //   Callbacks
    // =============
    _defineProperty(_this2, "onModerateButtonClick", function () {
      _this2.props.onModerateButtonClick(_this2.props.rowData);
    });
    _defineProperty(_this2, "onAccommodationsClick", function () {
      if (!_this2.props.onAccommodationsClick) return;
      _this2.props.onAccommodationsClick(_this2.props.rowData);
    });
    _defineProperty(_this2, "generateAttemptLink", function (autogradefailed, message, quizSessionId, attemptNumber) {
      var iconTitle = t('Autograde error on attempt { attemptNumber }.', {
        attemptNumber: attemptNumber
      });
      var autoGradeFailedProps = {
        icon: jsx(IconWarningLine, {
          color: "warning",
          title: iconTitle
        }),
        iconPlacement: 'end'
      };
      return jsx("div", {
        key: quizSessionId,
        css: _this2.props.styles.tableDataItem
      }, jsx(Link, Object.assign({
        onClick: _this2.onResultsLinkClick(quizSessionId),
        "data-automation": "sdk-moderation-attempts-results-link"
      }, autogradefailed && autoGradeFailedProps), message));
    });
    _defineProperty(_this2, "generateAttemptText", function (autogradefailed, message, quizSessionId, attemptNumber) {
      var iconTitle = t('Autograde error on attempt { attemptNumber }.', {
        attemptNumber: attemptNumber
      });
      var icon = autogradefailed ? jsx(IconWarningLine, {
        color: "warning",
        title: iconTitle
      }) : null;
      return jsx("div", {
        key: quizSessionId,
        css: _this2.props.styles.tableDataItem
      }, jsx(View, {
        margin: "0 x-small 0 0"
      }, message), icon);
    });
    return _this2;
  }
  _inherits(ModerateTableRow, _withI18nSupport);
  return _createClass(ModerateTableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.rowData.id === this.props.focusTarget && this.moderateButton) {
        this.moderateButton.focus();
      }
    }
  }, {
    key: "onResultsLinkClick",
    value: function onResultsLinkClick(quizSessionId) {
      var _this3 = this;
      return function () {
        _this3.props.onResultsLinkClick(quizSessionId);
      };
    }

    // =============
    //   RENDERING
    // =============
  }, {
    key: "renderScores",
    value: function renderScores(quizSessions) {
      var _this4 = this;
      var noScore = jsx("div", {
        css: this.props.styles.tableDataItem
      }, jsx(AccessibleContent, {
        alt: t('No Score')
      }, DASHES));
      if (!quizSessions.length) return noScore;
      return quizSessions.reduce(function (renderedScores, quizSession) {
        var result = quizSession.findAuthoritativeResult();
        if (!result) {
          return renderedScores;
        }
        var message = t('No Score');
        if (result.get('score') != null) {
          if (_this4.props.displayScoreAsPercentage) {
            var percentage = result.get('score') / result.get('pointsPossible');
            message = _this4.formatPercentMax2FractionDigits(percentage);
          } else {
            message = "".concat(t.number(result.get('score')), "/").concat(t.number(result.get('pointsPossible')));
          }
        }
        if (result.get('pointsPossible') === 0) {
          message = t('N/A');
        }
        if (quizSession.inProgress() || quizSession.reopeningGraded()) {
          var alt = t('In progress, score not available');
          message = jsx(AccessibleContent, {
            alt: alt
          }, DASHES);
        }
        renderedScores.push(jsx("div", {
          key: result.get('id'),
          css: _this4.props.styles.tableDataItem
        }, message));
        return renderedScores;
      }, []);
    }
  }, {
    key: "attemptMessage",
    value: function attemptMessage(idx, maxAttempts) {
      var message;
      if (maxAttempts === Infinity) {
        message = t('Attempt { attemptNumber }', {
          attemptNumber: idx + 1
        });
      } else {
        message = t('Attempt { attemptNumber } / { maxAttempts }', {
          attemptNumber: idx + 1,
          maxAttempts: maxAttempts
        });
      }
      return message;
    }
  }, {
    key: "renderAttempts",
    value: function renderAttempts(quizSessions) {
      var _this5 = this;
      var maxAttempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : quizSessions.length;
      if (!quizSessions.length) {
        return jsx("div", {
          css: this.props.styles.tableDataItem
        }, jsx(AccessibleContent, {
          alt: t('No Attempt')
        }, DASHES));
      }
      return quizSessions.map(function (quizSession, idx) {
        var quizSessionId = quizSession.get('id');
        var hasAutogradeFailure = quizSession.findAuthoritativeResult().status === 'autograding_failed';
        var message = _this5.attemptMessage(idx, maxAttempts, hasAutogradeFailure);
        if (_this5.props.onResultsLinkClick && quizSession.graded()) {
          return _this5.generateAttemptLink(hasAutogradeFailure, message, quizSessionId, idx + 1);
        } else {
          return _this5.generateAttemptText(hasAutogradeFailure, message, quizSessionId, idx + 1);
        }
      });
    }
  }, {
    key: "renderTimes",
    value: function renderTimes(quizSessions) {
      var _this6 = this;
      if (!quizSessions.length) {
        return jsx("div", {
          css: this.props.styles.tableDataItem
        }, jsx(AccessibleContent, {
          alt: t('No Time')
        }, DASHES));
      }
      return quizSessions.map(function (quizSession, idx) {
        var message = jsx(FormattedDuration, {
          seconds: quizSession.elapsedTime
        });
        if (quizSession.inProgress() || quizSession.reopeningGraded()) {
          var alt = t('In progress, time not available');
          message = jsx(AccessibleContent, {
            alt: alt
          }, DASHES);
        }
        return jsx("div", {
          key: quizSession.get('id'),
          css: _this6.props.styles.tableDataItem
        }, message);
      });
    }
  }, {
    key: "renderLogMessage",
    value: function renderLogMessage() {
      var multipleSessionAttempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var message = arguments.length > 1 ? arguments[1] : undefined;
      return jsx(React.Fragment, null, jsx(Text, {
        color: multipleSessionAttempt ? 'danger' : 'brand'
      }, message), multipleSessionAttempt && jsx(Tooltip, {
        renderTip: t('Multiple sessions detected'),
        placement: "end",
        on: ['click', 'hover', 'focus']
      }, jsx(IconButton, {
        screenReaderLabel: t('Multiple sessions detected'),
        color: 'danger',
        size: 'small',
        renderIcon: IconWarningSolid,
        withBackground: false,
        withBorder: false
      })));
    }
  }, {
    key: "renderLogLinks",
    value: function renderLogLinks(quizSessions) {
      var _this7 = this;
      if (!quizSessions.length) {
        return jsx("div", {
          css: this.props.styles.tableDataItem
        }, jsx(AccessibleContent, {
          alt: t('No Log')
        }, DASHES));
      }
      var _this$props = this.props,
        onModerateLogClick = _this$props.onModerateLogClick,
        id = _this$props.rowData.id;
      return quizSessions.map(function (quizSession) {
        var quizSessionId = quizSession.get('id');
        var message = quizSession.inProgress() || quizSession.reopeningGraded() ? t('In Progress') : t('View Log');
        var logMessage = _this7.renderLogMessage(quizSession.get('multipleSessionAttempt'), message);
        function onClick(event) {
          onModerateLogClick({
            id: id,
            event: event,
            quizSessionId: quizSessionId
          });
        }
        return jsx("div", {
          key: quizSessionId,
          css: _this7.props.styles.tableDataItem
        }, jsx(Link, {
          onClick: onClick,
          "data-automation": "sdk-moderation-moderate-session-log-link"
        }, logMessage));
      });
    }
  }, {
    key: "renderAccommodations",
    value: function renderAccommodations(accommodations) {
      if (this.props.onAccommodationsClick) {
        // Establish what to display about the accommodations
        var displayContent;
        if (!accommodations || accommodations.length === 0) {
          displayContent = jsx(Text, {
            color: "secondary"
          }, t('None'));
        } else {
          displayContent = jsx(List, {
            isUnstyled: true
          }, accommodations.map(function (elem) {
            return jsx(List.Item, {
              key: elem.name
            }, jsx(Text, {
              color: "primary"
            }, t('{ name }: { value }', elem)));
          }));
        }
        return jsx(Table.Cell, {
          "data-automation": "sdk-moderate-accommodations-text"
        }, displayContent);
      }
    }
  }, {
    key: "renderModerate",
    value: function renderModerate() {
      if (this.props.shouldRenderModerateButton) {
        return jsx(Table.Cell, null, jsx("div", {
          css: this.props.styles.moderateButton
        }, jsx(IconButton, {
          onClick: this.onModerateButtonClick,
          ref: this.handleModerateRef,
          "data-automation": "sdk-moderation-moderate-button",
          screenReaderLabel: t('Moderate')
        }, jsx(IconEditLine, null))));
      }
    }
  }, {
    key: "renderName",
    value: function renderName(name, avatarName) {
      return jsx(Link, {
        onClick: this.onAccommodationsClick,
        screenReaderLabel: t('Edit course accommodations'),
        "data-automation": "sdk-moderate-accommodations-edit",
        margin: "0 small",
        css: avatarName
      }, name);
    }
  }, {
    key: "render",
    value: function render() {
      var quizSessions = this.props.quizSessions.toArray();
      var _this$props$rowData = this.props.rowData,
        name = _this$props$rowData.name,
        avatarUrl = _this$props$rowData.avatar,
        maxAttempts = _this$props$rowData.maxAttempts,
        accommodations = _this$props$rowData.accommodations;
      var _this$props$styles = this.props.styles,
        avatarRow = _this$props$styles.avatarRow,
        avatarName = _this$props$styles.avatarName;
      return jsx(Table.Row, null, jsx(Table.RowHeader, null, jsx("span", {
        css: avatarRow
      }, jsx(PresentationContent, null, jsx(Avatar, {
        name: name,
        src: avatarUrl,
        size: "small"
      })), this.renderName(name, avatarName))), !this.props.anonymousGrading && jsx(Table.Cell, null, this.renderAttempts(quizSessions, maxAttempts)), !this.props.anonymousGrading && jsx(Table.Cell, null, this.renderScores(quizSessions)), !this.props.anonymousGrading && jsx(Table.Cell, null, this.renderTimes(quizSessions)), !this.props.anonymousGrading && jsx(Table.Cell, null, this.renderLogLinks(quizSessions)), !this.props.anonymousGrading && this.renderAccommodations(accommodations), this.renderModerate());
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_ModerateTableRow, "displayName", 'ModerateTableRow'), _defineProperty(_ModerateTableRow, "componentId", "Quizzes".concat(_ModerateTableRow.displayName)), _defineProperty(_ModerateTableRow, "propTypes", {
  anonymousGrading: PropTypes.bool.isRequired,
  displayScoreAsPercentage: PropTypes.bool,
  onModerateButtonClick: PropTypes.func.isRequired,
  onModerateLogClick: PropTypes.func.isRequired,
  onAccommodationsClick: PropTypes.func,
  quizSessions: ImmutablePropTypes.list.isRequired,
  // We are protecting against the absent prop below.
  onResultsLinkClick: PropTypes.func,
  rowData: PropTypes.shape({
    avatar: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    quizSessionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    maxAttempts: PropTypes.number,
    accommodations: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }))
  }).isRequired,
  shouldRenderModerateButton: PropTypes.bool,
  focusTarget: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_ModerateTableRow, "defaultProps", {
  displayScoreAsPercentage: true,
  shouldRenderModerateButton: true,
  focusTarget: null,
  onAccommodationsClick: null
}), _ModerateTableRow)) || _class);
export default ModerateTableRow;